import ActionIconButton from "../shared/ActionIconButton";
import { useWorkspaceSelection } from "./WorkspaceSelectionContext";

export default function WorkspaceSelectionToggle({ item }) {
  const { isSelected, toggleItem } = useWorkspaceSelection();
  const selected = isSelected(item);
  const label = selected ? "Убрать из подборки" : "Добавить в подборку";

  return (
    <ActionIconButton
      icon={selected ? "check" : "bookmark"}
      label={label}
      active={selected}
      aria-pressed={selected}
      onClick={() => toggleItem(item)}
    />
  );
}
